class AnnouncementMarquee extends HTMLElement {
  #frame;
  #lastTime = 0;
  #offset = 0;
  #groupWidth = 0;
  #resizeObserver;
  #motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  connectedCallback() {
    this.#resizeObserver = new ResizeObserver(() => this.#measure());
    this.#resizeObserver.observe(this);

    this.#motionQuery.addEventListener('change', this.#handleMotionChange);
    this.#measure();
    this.#handleMotionChange();
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.#frame);
    this.#resizeObserver?.disconnect();
    this.#motionQuery.removeEventListener('change', this.#handleMotionChange);
  }

  #measure() {
    const firstGroup = this.querySelector('.announcement-bar__marquee-group');
    if (!firstGroup) return;

    const previousWidth = this.#groupWidth;
    const nextWidth = firstGroup.getBoundingClientRect().width;

    if (nextWidth <= 0) return;

    if (previousWidth > 0) {
      this.#offset = (this.#offset / previousWidth) * nextWidth;
    }

    this.#groupWidth = nextWidth;
  }

  #handleMotionChange = () => {
    cancelAnimationFrame(this.#frame);
    this.#lastTime = 0;

    if (this.#motionQuery.matches) {
      this.removeAttribute('data-enhanced');
      this.style.removeProperty('transform');
      return;
    }

    this.setAttribute('data-enhanced', '');
    this.#frame = requestAnimationFrame(this.#tick);
  };

  #tick = (time) => {
    if (!this.#lastTime) this.#lastTime = time;

    const elapsed = Math.min(time - this.#lastTime, 50);
    this.#lastTime = time;

    const isPaused = this.matches(':hover') || this.contains(document.activeElement) || document.hidden;
    const duration = Math.max(Number(this.dataset.duration) || 40, 1);

    if (!isPaused && this.#groupWidth > 0) {
      const pixelsPerMillisecond = this.#groupWidth / (duration * 1000);
      this.#offset = (this.#offset + elapsed * pixelsPerMillisecond) % this.#groupWidth;
      this.style.transform = `translate3d(${-this.#offset}px, 0, 0)`;
    }

    this.#frame = requestAnimationFrame(this.#tick);
  };
}

if (!customElements.get('announcement-marquee')) {
  customElements.define('announcement-marquee', AnnouncementMarquee);
}
